import get from "lodash/get";

export const getCurrentClanId = state => state.currentAccount.clanId;

export const getCurrentClan = state => state.clans.items[state.currentAccount.clanId];

export const getCurrentBase = state => get(state.supply, [state.currentAccount.clanId, 'base'], null);

export const isFetchingCurrentBase = state => get(state.supply, [state.currentAccount.clanId, 'isFetching'], false);